import { DetailedHTMLProps, HTMLAttributes } from 'react';

export type NavigationProps = DetailedHTMLProps<
    HTMLAttributes<HTMLElement>,
    HTMLElement
>;

const Navigation = (props: NavigationProps) => <nav {...props} />;

export default Navigation;
